<div class="content-block">
  <div class="qrcode-wrap">
    <div class="qrcode-box">
      <qrcode [qrdata]="url" [width]="350" [errorCorrectionLevel]="'M'"></qrcode>
    </div>
  </div>
</div>
